<template>
  <div class="sub">
    <div class="subhead">
      <b>{{ checked }} of {{ substeps.length }} steps checked</b>
      <span class="subnote">
        Set up → intro session → collect → analyse → present. Tick items off
        below as you go — this is just for your own tracking; your trainer
        confirms the overall step with you.
      </span>
    </div>
    <ul>
      <li
        v-for="item in substeps"
        :key="item.id"
        :class="['subitem', substepsDone.includes(item.id) ? 'is-checked' : '']"
        @click="$emit('toggle', item.id)"
      >
        <span class="box">
          <span v-if="substepsDone.includes(item.id)" class="btick">✓</span>
        </span>
        <span class="stxt">
          <b>{{ item.title }}</b>
          <span class="stxt-body" v-html="item.text" />
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SubChecklist',
  props: {
    substeps: {
      type: Array,
      required: true
    },
    substepsDone: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    checked () {
      return this.substeps.filter((s) =>
        this.substepsDone.includes(s.id)
      ).length
    }
  }
}
</script>

<style scoped>
.sub {
  margin-top: 16px;
  border-top: 1px dashed var(--line);
  padding-top: 14px;
}
.subhead {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}
.subhead b {
  font-size: 0.9rem;
}
.subnote {
  font-size: 0.82rem;
  color: var(--ink-soft);
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.subitem {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--paper);
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.subitem.is-checked {
  border-color: rgba(31, 157, 107, 0.4);
  background: #f2faf6;
}
.box {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid var(--ink-soft);
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  margin-top: 1px;
  background: var(--white);
}
.is-checked .box {
  background: var(--ok);
  border-color: var(--ok);
}
.btick {
  color: #fff;
  font-size: 0.75rem;
  font-weight: 800;
}
.stxt {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.stxt b {
  font-size: 0.92rem;
}
.stxt-body {
  font-size: 0.85rem;
  color: var(--ink-soft);
}
</style>

<style>
.subitem .stxt-body a {
  color: var(--teal-dk);
}
</style>
